import React from 'react';
import { Box, Typography, Paper, Button, Stack, Chip } from '@mui/material';
import { format } from 'date-fns';
import Event from './Event';
import MonouEvent from './MonouEvent';
import type { EventItem } from './EventList';

interface EventDetailProps {
  event: EventItem | null;
  onBack: () => void;
}

const EventDetail: React.FC<EventDetailProps> = ({ event, onBack }) => {
  if (!event) {
    return (
      <Box sx={{ pt: { xs: 7, sm: 8 }, textAlign: 'center' }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          イベントが見つかりませんでした
        </Typography>
        <Button variant="outlined" onClick={onBack}>一覧に戻る</Button>
      </Box>
    );
  }

  const isMonque = event.title.includes('もんクエ');
  const isMonou = event.title.includes('もん王');

  if (isMonque) {
    return (
      <Box sx={{ pt: { xs: 7, sm: 8 } }}>
        <Event />
      </Box>
    );
  }

  if (isMonou) {
    return (
      <Box sx={{ pt: { xs: 7, sm: 8 } }}>
        <MonouEvent />
      </Box>
    );
  }

  return (
    <Box sx={{ pt: { xs: 7, sm: 8 }, px: 2, pb: 3 }}>
      <Paper sx={{ p: 3 }}>
        <Stack spacing={1.5}>
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            {event.title}
          </Typography>
          <Chip label="イベント詳細" color="primary" size="small" sx={{ alignSelf: 'flex-start' }} />
          <Typography variant="body2" color="text.secondary">
            開始: {format(new Date(event.start_at), 'yyyy/MM/dd HH:mm')}
          </Typography>
          {event.open_at && (
            <Typography variant="body2" color="text.secondary">
              開場: {format(new Date(event.open_at), 'yyyy/MM/dd HH:mm')}
            </Typography>
          )}
          <Typography variant="body2" color="text.secondary">
            会場: {event.venue || '未定'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            詳細ページは準備中です。
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
};

export default EventDetail;
